<template>
  <nav class="event-page-nav" v-if="pageNav">
    <ul>
      <template v-for="(item, id, index) in pageNav">
        <li :key="'nav' + index"
          :class="{
            'event-page-nav-prev': id === 'prev',
            'event-page-nav-next': id === 'next'
          }">
          <router-link v-if="routeName"
            :to="{ name: routeName, params: { id: item.id }}"
            :title="buttonData[id]"
            class="event-page-nav-link"
            :class="{
              'event-page-nav-link-with-details': item.title
            }">
            <svg v-if="id === 'prev'">
              <use class="not-on-dark" xlink:href="#arrowLeftDarkSvg"></use>
              <use class="on-dark" xlink:href="#arrowLeftSvg"></use>
            </svg>
            <svg v-if="id === 'next'">
              <use class="not-on-dark" xlink:href="#arrowRightDarkSvg"></use>
              <use class="on-dark" xlink:href="#arrowRightSvg"></use>
            </svg>

            <div class="event-page-nav-details" v-if="item.title">
              <h5>
                {{ item.title }}
              </h5>
              <p v-if="item.details" class="text-uppercase">
                {{ item.details }}
              </p>
            </div>
          </router-link>
        </li>
      </template>
    </ul>
  </nav>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'EventPageNav',
  props: ['pageNav', 'routeName'],
  computed: {
    ...mapGetters([
      'buttonData'
    ])
  }
}
</script>

<style scoped lang="scss">
.event-page-nav {
  padding: 0 0 $gap-xl 0;

  @include screen ('sm') {
    padding: $gap-xl 0 ceil($gap-xl * 1.5);
  }

  ul {
    list-style: none;
    overflow: hidden;
    margin: 0;
    padding: 0;
    width: 100%;
  }

  li, a {
    display: inline-block;
  }

  li {
    max-width: 45%;
  }

  svg {
    height: $arrow-small;
    position: absolute;
    top: 0;
    width: $arrow-small;
  }

  &-prev {
    float: left;
    text-align: left;

    svg {
      left: 0;
    }
  } // END .event-page-nav-prev;
  &-next {
    float: right;
    text-align: right;

    svg {
      right: 0;
    }
  } // END .event-page-nav-next;

  &-link {
    color: $text-dark;
    min-height: ($arrow-small * 2);
    padding: 0 ($arrow-small + $gap-sm);
    position: relative;
    text-decoration: none;
    width: 100%;

    &-with-details {
      svg {
        top: $gap-sm;
      }
    }

    &:hover, &:focus {
      h5 {
        color: $text-accent;
      }
    }

    #app.hight-contrast & {
      color: $contrast-accent;

      &:hover, &:focus {
        h5 {
          color: $contrast-text;
        }
      }
    }
  } // END .event-page-nav-link;

  &-details {
    display: none;
    padding: $gap-sm 0;

    h5, p {
      font: {
        size: $font-xs;
        weight: 500;
      }
      margin: 0;
      padding: 0.25em 0;
    }

    @include screen ('md') {
      display: inline-block;
    }
  } // END .event-page-nav-details;

} // END .event-page-nav;
</style>
